module.exports = __webpack_public_path__ + "static/media/icon-phone.6552aa43.png";